import { render, staticRenderFns } from "./ModalAdmin.vue?vue&type=template&id=0761f08d&scoped=true"
import script from "./ModalAdmin.vue?vue&type=script&lang=js"
export * from "./ModalAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalAdmin.vue?vue&type=style&index=0&id=0761f08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761f08d",
  null
  
)

export default component.exports